import { render, staticRenderFns } from "./communitybusiness.vue?vue&type=template&id=242dc9a7&scoped=true"
import script from "./communitybusiness.vue?vue&type=script&lang=js"
export * from "./communitybusiness.vue?vue&type=script&lang=js"
import style0 from "./communitybusiness.vue?vue&type=style&index=0&id=242dc9a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242dc9a7",
  null
  
)

export default component.exports